<app-loading-spinner *ngIf="isLoading" />

<div *ngIf="!isLoading">
    <div
        class="flex flex-row items-center gap-6 font-semibold dark:text-white text[#424242] mb-4 mr-5 ml-0 cursor-pointer">
        <p onclick="history.back()">Centres</p>
        <p>Centre Dashboard</p>
    </div>

    <!-- Row 1: matching grid-cols-5 -->
    <div class="grid grid-cols-5 gap-6">

        <!-- WPCK02 (col-span-1) -->
        <div class="col-span-1 relative cursor-pointer flex items-center py-4 px-4 bg-tileLight dark:bg-[#363636] shadow-lg rounded-lg"
            (click)="editCentre(centerData.id)">
            <p class="font-bold text-black text-lg dark:text-white mx-auto">
                {{centerData.regCode}}
            </p>
            <i class="fa-solid fa-pencil text-[blue] absolute right-4 cursor-pointer"></i>
        </div>

        <!-- View Market Price (col-span-2) -->
        <div class="col-span-2 flex flex-row items-center justify-between px-10 py-4 bg-tileLight dark:bg-[#363636] shadow-lg rounded-lg cursor-pointer"
            (click)="navigateToMarketPrice()">
            <div class="w-3 h-3"></div>
            <p class="font-bold text-black text-lg dark:text-white">View Market Price</p>
            <i class="fa-solid fa-arrow-up-right-from-square text-[#415CFF] text-xl"></i>
        </div>

        <!-- Assign Centre Target (col-span-2) -->
        <div class="col-span-2 flex flex-row items-center justify-center py-4 bg-[#415CFF] shadow-lg rounded-lg cursor-pointer"
            (click)="navigateAddTarget()">
            <p class="font-bold text-tileLight text-lg">Assign Centre Target</p>
        </div>

    </div>

    <!-- Row 2: same grid-cols-5 -->
    <div class="grid grid-cols-5 gap-6 my-8">

        <!-- Current Target (col-span-1) -->
        <div class="col-span-1 flex flex-col justify-between items-center py-4 bg-tileLight dark:bg-[#363636] shadow-lg rounded-lg cursor-pointer"
            (click)="viewCenterTarget()">
            <div class="w-full"></div>
            <div class="flex flex-col justify-center items-center gap-y-3">
                <i class="fa-solid fa-bullseye text-[#415CFF] text-5xl"></i>
                <div class="flex flex-col justify-center items-center cursor-default">
                    <p class="font-bold text-black text-lg dark:text-white">Current</p>
                    <p class="font-bold text-black text-lg dark:text-white">Target</p>
                </div>
            </div>
            <div class="flex flex-row w-full items-center justify-end">
                <i class="fa-solid fa-arrow-up-right-from-square text-[#415CFF] text-xl mx-4"></i>
            </div>
        </div>

        <!-- Today Collection (col-span-2) -->
        <div
            class="col-span-2 flex flex-col items-center justify-center gap-3 py-5 bg-[#FB923C] shadow-lg rounded-lg cursor-default">
            <i class="fa-solid fa-layer-group text-2xl text-white"></i>
            <div class="flex flex-col justify-center items-center">
                <p class="font-bold text-white text-lg">Today Collection</p>
                <p class="font-bold text-white text-lg">
                    {{transCount < 10 ? '0' + transCount : transCount}} Transactions </p>
            </div>
            <p class="font-bold text-white text-2xl my-2">
                {{ transAmount | currency:'Rs. ':'symbol':'1.2-2' }}
            </p>
        </div>

        <!-- Total Collection Expense (col-span-1) -->
        <div class="col-span-1 flex flex-col justify-between pb-1 bg-tileLight dark:bg-[#363636] shadow-lg rounded-lg cursor-pointer"
            (click)="navigateCollectionExpenses()">
            <!-- <div class="flex flex-row items-center justify-end pt-2 pr-1">
                <i *ngIf="expencePrecentage >= 0" class="fa-solid fa-arrow-trend-up text-[#0D9488] mx-2"></i>
                <i *ngIf="expencePrecentage < 0" class="fa-solid fa-arrow-trend-down text-[#D70000] mx-2"></i>
                <p class="text-[#0D9488] dark:text-white text-sm"
                    [ngClass]="{ 'text-[#D70000]': expencePrecentage < 0 }">{{expencePrecentage}}</p>
            </div> -->
            <div class="flex flex-col items-center justify-center mx-3 gap-3 mt-5">
                <div class="bg-[#CCFBF1] p-3 rounded-full">
                    <i class="fa-solid fa-arrow-trend-up text-[#415CFF] text-2xl"></i>
                </div>
                <div class="flex flex-col justify-center items-center text-center">
                    <p class="text-[#627189] text-sm dark:text-white">Total Collection Expense</p>
                    <p class="font-bold text-black dark:text-white text-base">{{ totExpences | currency:'Rs.
                        ':'symbol':'1.2-2' }}</p>
                </div>
            </div>
            <div class="flex flex-row items-center justify-end gap-2 pb-2 pr-1">
                <p class="text-[#627189] dark:text-white text-sm">30 days</p>
                <i class="fa-solid fa-arrow-up-right-from-square text-[#415CFF] mx-3"></i>
            </div>
        </div>

        <!-- Officers (col-span-1) -->
        <div class="col-span-1 flex flex-col justify-between items-center py-4 bg-tileLight dark:bg-[#363636] shadow-lg rounded-lg cursor-pointer"
            (click)="navigateCenterOfficers()">
            <div class="w-full"></div>
            <div class="flex flex-col justify-center items-center gap-y-3 cursor-default">
                <i class="fa-solid fa-users text-3xl dark:text-white"></i>
                <div class="flex flex-col justify-center items-center">
                    <p class="font-bold text-black text-lg dark:text-white">Officers</p>
                    <p class="font-bold text-black text-lg dark:text-white">
                        {{centerNameObj.officerCount < 10 ? '0' + centerNameObj.officerCount :
                            centerNameObj.officerCount}} </p>
                </div>
            </div>
            <div class="flex flex-row w-full items-center justify-end">
                <i class="fa-solid fa-arrow-up-right-from-square text-[#415CFF] mx-4"></i>
            </div>
        </div>

    </div>

    <div class="w-full px-10 py-7 bg-tileLight dark:bg-[#363636] shadow-lg rounded-lg my-8">
        <div class="flex flex-row items-center gap-7">
            <div class="py-1 font-semibold text-[#627189] cursor-pointer"
                [ngClass]="{ 'border-b-2 border-[#415CFF] text-black': selectTable==='collection' }"
                (click)="chooseTable('collection')">
                <p class="dark:text-white">Recent Collections</p>
            </div>

        </div>
        <div *ngIf="selectTable==='collection'" class="overflow-x-auto mt-8 mr-5 border-gray-100  rounded-lg ">
            <div *ngIf="hasData">
                <table class="w-full divide-y-2 overflow-hidden">
                    <thead class=" text-gray-700 dark:text-gray-300 dark:bg-[#0F0F0F] dark:border-[#202021]">
                        <tr>
                            <th class="px-6 py-4 text-left font-medium">No</th>
                            <th class="px-6 py-4 text-left font-medium">Crop Name</th>
                            <th class="px-6 py-4 text-left font-medium">Variety Name</th>
                            <th class="px-6 py-4 text-center font-medium">Grade</th>
                            <th class="px-6 py-4 text-center font-medium">Collected (kg)</th>
                            <th class="px-6 py-4 text-left font-medium">Value (Rs.)</th>
                            <th class="px-6 py-4 text-center font-medium">Date</th>
                        </tr>
                    </thead>
                    <tbody class="bg-white dark:bg-[#1D1D1F] dark:border-[#1D1D1F]">
                        <tr *ngFor="let item of resentCollectionArr; let i = index">
                            <td class="px-6 py-4 text-gray-900 dark:text-gray-300"> {{ (i + 1) < 10 ? '0' + (i + 1) : (i
                                    + 1) }} </td>
                            <td class="px-6 py-4 text-gray-900 dark:text-gray-300">{{item.cropNameEnglish}}</td>
                            <td class="px-6 py-4 text-gray-900 dark:text-gray-300">{{item.varietyNameEnglish}}</td>
                            <td class="px-6 py-4 text-gray-900 text-center dark:text-gray-300">{{item.grade}}</td>
                            <td class="px-6 py-4 text-gray-900 text-center dark:text-gray-300">{{item.totQty | number:
                                '1.2-2' }}</td>
                            <td class="px-6 py-4 text-gray-900 dark:text-gray-300">{{item.totPrice | number: '1.2-2' }}
                            </td>
                            <td class="px-6 py-4 text-gray-900 dark:text-gray-300">
                                <div class="flex flex-col items-center justify-center ">
                                    <p class="text-[#3E3E3E] dark:text-textDark">{{item.date | date:'yyyy/MM/dd'}}</p>
                                    <p class="text-[#3E3E3E] dark:text-textDark">{{item.date | date:'hh:mm a'}}</p>
                                </div>
                            </td>
                        </tr>
                    </tbody>

                </table>
            </div>

            <div *ngIf="!hasData"
                class="flex flex-col items-center w-full h-screen px-10 py-7 bg-tileLight dark:bg-[#363636] dark:text-textDark mt-6">
                <p class="text-[#494949] my-6 dark:text-textDark">--No Data Availabale--</p>
                <img src="assets/images/NoData.png" alt="No Data" class="w-20 h-20 dark:text-textDark" />
            </div>
        </div>
    </div>
</div>